export const GET_NOTCH_IMPACT_TEST_REQUEST = "GET_NOTCH_IMPACT_TEST_REQUEST";
export const GET_NOTCH_IMPACT_TEST_SUCCESS = "GET_NOTCH_IMPACT_TEST_SUCCESS";
export const GET_NOTCH_IMPACT_TEST_FAILURE = "GET_NOTCH_IMPACT_TEST_FAILURE";

export const DELETE_NOTCH_IMPACT_TEST_REQUEST = "DELETE_NOTCH_IMPACT_TEST_REQUEST";
export const DELETE_NOTCH_IMPACT_TEST_SUCCESS = "DELETE_NOTCH_IMPACT_TEST_SUCCESS";
export const DELETE_NOTCH_IMPACT_TEST_FAILURE = "DELETE_NOTCH_IMPACT_TEST_FAILURE";

export const CREATE_NOTCH_IMPACT_TEST_REQUEST = "CREATE_NOTCH_IMPACT_TEST_REQUEST";
export const CREATE_NOTCH_IMPACT_TEST_SUCCESS = "CREATE_NOTCH_IMPACT_TEST_SUCCESS";
export const CREATE_NOTCH_IMPACT_TEST_FAILURE = "CREATE_NOTCH_IMPACT_TEST_FAILURE";

export const EDIT_NOTCH_IMPACT_TEST_REQUEST = "EDIT_NOTCH_IMPACT_TEST_REQUEST";
export const EDIT_NOTCH_IMPACT_TEST_SUCCESS = "EDIT_NOTCH_IMPACT_TEST_SUCCESS";
export const EDIT_NOTCH_IMPACT_TEST_FAILURE = "EDIT_NOTCH_IMPACT_TEST_FAILURE";


export const UPLOADCSV_NOTCH_IMPACT_REQUEST = "UPLOADCSV_NOTCH_IMPACT_REQUEST";
export const UPLOADCSV_NOTCH_IMPACT_SUCCESS = "UPLOADCSV_NOTCH_IMPACT_SUCCESS";
export const UPLOADCSV_NOTCH_IMPACT_FAILURE = "UPLOADCSV_NOTCH_IMPACT_FAILURE";